/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router-dom components
import { Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import * as React from "react";
import { useEffect, useRef, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// @mui icons
// Material Dashboard 2 React components
import MDBox from "@/components/MDBox";
import MDTypography from "@/components/MDTypography";
import MDInput from "@/components/MDInput";
import MDButton from "@/components/MDButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MDDatePicker from "@/components/MDDatePicker";
import EDToggleButton from "@/components/EDToggleButton";
import UlazIcon from "@mui/icons-material/Login";
import IzlazIcon from "@mui/icons-material/Logout";

// Authentication layout components
// Images
import {
  readAnal,
  readPartner,
  readRoba,
  writeOdvaga,
  writePartner,
} from "@/components/APIService/apiService";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, Icon } from "@mui/material";
import { useMaterialUIController } from "../../context";
import InputAdornment from "@mui/material/InputAdornment";
import { trim } from "stylis";
import BasicLayout2 from "../authentication/components/BasicLayout2";

function Anal({ route }) {
  const APP_AUTH_SLOT = "EK_APP";

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [rememberMe, setRememberMe] = useState(false);

  const [kvalError, setKvalError] = useState({ Vlaga: false, Primjesa: false, Hektolitar: false });
  const [kvalValue, setKvalValue] = useState([]);
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [napomena, setNapomena] = useState(null);
  const [netto, setNetto] = useState(null);
  const [defaultNetto, setDefaultNetto] = useState(null);
  const [nettoError, setNettoError] = useState(false);
  const [direction, setDirection] = useState(null);
  const [vagarskiList, setvagarskiList] = useState("");
  const [vagarskiListError, setvagarskiListError] = useState(false);
  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [listRoba, setListRoba] = useState([]);
  const [listVlasnik, setListVlasnik] = useState([]);
  const [listPrimatelj, setListPrimatelj] = useState([]);
  const [listIsporucitelj, setListIsporucitelj] = useState([]);
  const [roba, setRoba] = useState(null);
  const [vlasnik, setVlasnik] = useState(null);
  const [primatelj, setPrimatelj] = useState(null);
  const [isporucitelj, setIsporucitelj] = useState(null);
  const [defaultRoba, setDefaultRoba] = useState(null);
  const [defaultVlasnik, setDefaultVlasnik] = useState(null);
  const [defaultPrimatelj, setDefaultPrimatelj] = useState(null);
  const [defaultIsporucitelj, setDefaultIsporucitelj] = useState(null);
  const [robaError, setRobaError] = useState(false);
  const [vlasnikError, setVlasnikError] = useState(false);
  const [primateljError, setPrimateljError] = useState(false);
  const [isporuciteljError, setIsporuciteljError] = useState(false);
  const previousController = useRef();
  // const analiza = ["Vlaga", "Primjesa", "Hektolitar"];
  const [analiza, setAnaliza] = useState([{}]);
  // const [avatars, setAvatars] = useState("");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [nazivValue, setNazivValue] = useState("");
  const [mjestoValue, setMjestoValue] = useState("");
  const [adresaValue, setAdresaValue] = useState("");
  const [nazivError, setNazivError] = useState(false);
  const [mjestoError, setMjestoError] = useState(false);
  const [adresaError, setAdresaError] = useState(false);
  const [noviPartner, setNoviPartner] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [okDisabled, setOkDisabled] = useState(false);
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [datum, setDatum] = useState(dayjs());

  if (cancel)
    navigate("/odvage", {
      result: "cancel",
    });

  const onButtonClick = () => {
    navigate("/odvage", {
      itemId: 86,
    });
  };

  async function handleSubmitAnaliza(event) {
    setOkDisabled(true);
    setLoading(true);
    await sleep(250);
    try {
      setvagarskiListError(false);
      if (!location.state.lokacija.oms) setvagarskiListError(!isNumber(vagarskiList));
      setRobaError(false);
      setVlasnikError(false);
      setPrimateljError(false);
      setIsporuciteljError(false);
      if (!roba) {
        setRobaError(true);
        // return;
      }
      if (!vagarskiList) {
        setvagarskiListError(true);
        // return;
      }
      if (!vlasnik) {
        setVlasnikError(true);
        // return;
      }
      if (!primatelj) {
        setPrimateljError(true);
        // return;
      }
      if (!isporucitelj) {
        setIsporuciteljError(true);
        // return;
      }
      if (
        robaError ||
        vagarskiListError ||
        vlasnikError ||
        primateljError ||
        isporuciteljError ||
        isKvalError()
      ) {
        return;
      }
      const response = await writeOdvaga({
        id: null,
        datum: datum.format("YYYY-MM-DD"),
        vagarskilist: vagarskiList,
        roba: roba,
        vlasnik_id: vlasnik.id,
        primatelj_id: primatelj.id,
        isporucitelj_id: isporucitelj.id,
        napomena: napomena,
        netto: netto,
        direction: direction ? direction : "U",
        kval: kvalValue,
        lokacija: location.state.lokacija,
        reg1: reg1,
        reg2: reg2,
      });
      switch (response.result) {
        case "OK":
          navigate("/odvage", {
            result: "OK",
          });
          break;
        default:
          //console.log(response.result);
          break;
      }
    } catch (error) {
      console.error("Error processing data:", error);
    } finally {
      setLoading(false);
      setOkDisabled(false);
    }
  }

  const isKvalError = () => Object.values(kvalError).includes(true);

  // console.log(isKvalError());

  async function handleSubmitPartner(event) {
    try {
      setNazivError(false);
      if (!nazivValue || nazivValue.length < 5) {
        setNazivError(true);
        return;
      }
      if (nazivError) {
        return;
      }
      const response = await writePartner({
        id: null,
        naziv: nazivValue.trim(),
        mjesto: mjestoValue.trim(),
        adresa: adresaValue.trim(),
      });
      // console.log(response);
      switch (response.result) {
        case "OK":
          setNoviPartner(false);
          break;
        case "Duplicate":
          break;
        default:
          // setNoviPartner(false);
          break;
      }
    } catch (error) {
      console.error("Error processing data:", error);
    }
  }

  const getRobaData = async (searchTerm, control) => {
    if (previousController.current) {
      previousController.current.abort();
    }
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;
    const result = await readRoba(searchTerm);
    const updatedOptions = result.map(({ id, sorta_id, roba_sorta_id, naziv }) => {
      return { id: roba_sorta_id, roba_id: id, sorta_id: sorta_id, title: naziv };
    });
    switch (control) {
      case "Roba":
        setListRoba(updatedOptions);
        break;
    }
    return updatedOptions;
  };

  const getPartnerData = async (searchTerm, control) => {
    if (previousController.current) {
      previousController.current.abort();
    }
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;
    const result = await readPartner(searchTerm);
    const updatedOptions = result.map(({ id, naziv }) => {
      return { id: id, title: naziv };
    });
    switch (control) {
      case "Vlasnik":
        setListVlasnik(updatedOptions);
        break;
      case "Primatelj":
        setListPrimatelj(updatedOptions);
        break;
      case "Isporucitelj":
        setListIsporucitelj(updatedOptions);
        break;
    }
    return updatedOptions;
  };

  useEffect(() => {
    setKvalValue({ ...kvalValue, id: location.state.id });
    !direction ? setDirection(location.state.direction) : direction;
    const fetchData = async () => {
      try {
        setLoading(true);
        if (!roba || true) {
          const result = await readAnal(
            location.state.id,
            location.state.lokacija,
            direction,
            roba
          );
          let a = [];
          let b = {};
          result.analiza &&
            result.analiza.map(function (item) {
              a.push(item);
              b[item.fname] = item.value;
            });
          if (result.header) {
            const rob = await getRobaData(
              "id=" + result.header.roba_id + "." + result.header.sorta_id,
              "Roba"
            );
            const vlas = await getPartnerData("id=" + result.header.vlasnik_id, "Vlasnik");
            const prim = await getPartnerData("id=" + result.header.primatelj_id, "Primatelj");
            const ispo = await getPartnerData(
              "id=" + result.header.isporucitelj_id,
              "Isporucitelj"
            );
            setAnaliza(a);
            setKvalValue(b);
            if (!roba) {
              setDefaultRoba(rob[0] ? rob[0] : null);
              setRoba(rob[0] ? rob[0] : null);
            }
            !vlasnik && setDefaultVlasnik(vlas[0] ? vlas[0] : null);
            !vlasnik && setVlasnik(vlas[0] ? vlas[0] : null);
            !primatelj && setDefaultPrimatelj(prim[0] ? prim[0] : null);
            !primatelj && setPrimatelj(prim[0] ? prim[0] : null);
            !isporucitelj && setDefaultIsporucitelj(ispo[0] ? ispo[0] : null);
            !isporucitelj && setIsporucitelj(ispo[0] ? ispo[0] : null);
            !vagarskiList && setvagarskiList(location.state.id);
            !netto && setNetto(result.header.netto);
            !datum && setDatum(dajjs(result.header.datum));
            !direction && setDirection(result.header.direction);
            !napomena && setNapomena(result.header.napomena);
          }
        }
      } catch (error) {
        console.error("Error processing data:", error);
      } finally {
        //setvagarskiListError(location.state.id);
        setLoading(false);
      }
    };
    fetchData();
  }, [roba]);

  if (loading || !analiza) {
    return (
      <MDBox mt={2} justifyContent="center" sx={{ display: "flex" }}>
        <CircularProgress color="inherit" />
      </MDBox>
    );
  }

  // const avatars = analiza.map(({ name, value, fname, min, max }) => {
  const avatars = Object.entries(analiza).map(([key, item]) => {
    // console.log(key, item, item.name, item.value);
    // console.log(kvalValue);
    // return;
    return (
      <MDBox mb={2} textAlign="center">
        <MDInput
          type="number"
          label={item.name}
          // defaultValue={kvalValue[name]}
          value={kvalValue[item.fname]}
          // error={passwordError}
          //fullWidth
          // value={password}
          sx={{ width: "6rem" }}
          error={kvalError[item.fname]}
          key={item.fname}
          inputProps={{
            "data-name": item.fname,
            "data-min": item.min,
            "data-max": item.max,
            style: { textAlign: "left" },
          }}
          onChange={(e) => handleChangeKval(e)}
          size={"small"}
          // endAdornment={<InputAdornment position="end">%</InputAdornment>}
          // onChange={handleChange}
          // onChange={e => /setFirstName(e.target.value)
          // onChange={(e) => setKvalValue((kvalValue) => ({ name: e.target.value }))}
          // onChange=setKvalValue({ name: value })
        />
      </MDBox>
    );
  });

  // const handleChange = (e) => {
  function handleChangeKval(e) {
    let value = e.target.valueAsNumber;
    value = isNaN(value) ? "" : value;
    let id = e.target.getAttribute("data-name");
    let min = Number(e.target.getAttribute("data-min"));
    let max = Number(e.target.getAttribute("data-max"));
    let test = true;
    if (!value.empty && value >= min && value <= max) {
      test = false;
    }
    test = value.length === 0 ? false : !(value >= min && value <= max);
    setKvalError({ ...kvalError, [id]: test });
    setKvalValue({ ...kvalValue, [id]: value });
  }

  function handleChangeNetto(e) {
    let value = trim(e.target.value);
    setNetto(value);
    setNettoError(!isNumber(value));
  }

  function handleChangeVagarskiList(e) {
    let value = trim(e.target.value);
    setvagarskiList(value);
    setvagarskiListError(!isNumber(value));
  }

  function handleChangeReg1(e) {
    let value = trim(e.target.value);
    setReg1(value);
  }

  function handleChangeReg2(e) {
    let value = trim(e.target.value);
    setReg2(value);
  }

  function handleChange(e) {
    let value = e.target.value;
    let id = e.target.getAttribute("data-name");
    setKvalValue({ ...kvalValue, [id]: value });
  }

  function isNumber(value) {
    if (value === "") value = "0";
    return typeof value === "string" && !isNaN(value) && !isNaN(parseFloat(value));
  }

  const onRobaInputChange = (event, value, reason) => {
    // console.log(event);
    // console.log(new Error().stack);
    value.trim();
    if (value && event) {
      getRobaData(value, event.currentTarget.id);
    } else if (event) {
      switch (event.currentTarget.id) {
        case "Roba":
          setListRoba([]);
          break;
      }
    }
  };

  const onPartnerInputChange = (event, value, reason) => {
    // console.log(event);
    // console.log(new Error().stack);
    value.trim();
    if (value && event) {
      getPartnerData(value, event.currentTarget.id);
    } else if (event) {
      switch (event.currentTarget.id) {
        case "vlasnik":
          setListVlasnik([]);
          break;
        case "primatelj":
          setListPrimatelj([]);
          break;
        case "isporucitelj":
          setListIsporucitelj([]);
          break;
      }
    }
  };

  if (localStorage.getItem(APP_AUTH_SLOT) === null) return <Navigate to="/" />;

  if (!avatars) return;

  const snpOn = () => setNoviPartner(true);
  const snpOff = () => setNoviPartner(false);
  const cancelON = () => setCancel(true);
  const okD = (state) => setOkDisabled(state);

  if (noviPartner)
    return (
      <BasicLayout2 image={""}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Partner
            </MDTypography>
          </MDBox>
          <MDBox pt={2} pb={3} px={3} textAlign="center">
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label={"Naziv"}
                  value={nazivValue}
                  fullWidth
                  error={nazivError}
                  key={"naselje"}
                  onChange={(e) => setNazivValue(() => e.target.value)}
                />
              </MDBox>
              <Grid mb={0} item xs={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                <Grid item xs={5}>
                  <MDBox mb={2} mr={1}>
                    <MDInput
                      type="text"
                      label={"Mjesto"}
                      value={mjestoValue}
                      fullWidth
                      error={mjestoError}
                      key={"mjesto"}
                      onChange={(e) => setMjestoValue(() => e.target.value)}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={7}>
                  <MDBox mb={1}>
                    <MDInput
                      type="search"
                      label={"Ulica i broj"}
                      value={adresaValue}
                      fullWidth
                      error={adresaError}
                      key={"adresa"}
                      onChange={(e) => setAdresaValue(() => e.target.value)}
                    />
                  </MDBox>
                </Grid>
              </Grid>
              <Grid mb={0} item xs={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                <Grid item xs={4} mr={2}>
                  <MDBox mt={4} mb={1}>
                    {/*<MDButton variant="gradient" color="info" onClick={onButtonClick} fullWidth>*/}
                    <MDButton variant="gradient" color="error" onClick={snpOff} fullWidth>
                      Cancel
                    </MDButton>
                  </MDBox>
                </Grid>
                <Grid item xs={8}>
                  <MDBox mt={4} mb={1}>
                    {/*<MDButton variant="gradient" color="info" onClick={onButtonClick} fullWidth>*/}
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={(e) => handleSubmitPartner(e)}
                      fullWidth
                    >
                      OK
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </Card>
      </BasicLayout2>
    );

  return (
    <BasicLayout2 image={""}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDBox display={"flex"} justifyContent={"space-between"}>
            <MDTypography variant="h6" color="white">
              {location.state.id}
            </MDTypography>
            <MDTypography variant="h6" color="white">
              {location.state.netto}&nbsp;kg
            </MDTypography>
          </MDBox>
          <MDTypography variant="h6" color="white">
            {location.state.roba}
          </MDTypography>
          {location.state.company && (
            <MDBox display={"flex"} justifyContent={"space-between"}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                color={"white"}
                textTransform={"none"}
              >
                Partner:&nbsp;
                <MDTypography
                  variant="button"
                  fontWeight="light"
                  color={"white"}
                  textTransform="capitalize"
                >
                  {location.state.company}
                </MDTypography>
              </MDTypography>
            </MDBox>
          )}
          {location.state.napomena && (
            <MDBox display={"flex"} justifyContent={"space-between"}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                color={"white"}
                textTransform={"none"}
              >
                Opis:&nbsp;
                <MDTypography
                  variant="button"
                  fontWeight="light"
                  color={"white"}
                  textTransform="capitalize"
                >
                  {location.state.napomena}
                </MDTypography>
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
        <MDBox px={2} py={1}>
          <MDBox component="form" role="form" justifyContent={"space-between"} mt={1}>
            {!location.state.lokacija.oms && (
              <MDBox display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                <MDBox mb={2} mr={{ xs: 0.5 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MDDatePicker
                      type={"date"}
                      label="Datum"
                      value={datum}
                      size={"small"}
                      onChange={(newValue) => setDatum(newValue)}
                      inputFormat="DD.MM.YYYY"
                      renderInput={(params) => <MDInput {...params} size={"small"} />}
                      disableFuture
                    />
                  </LocalizationProvider>
                </MDBox>
                <MDBox mb={2} ml={{ xs: 0.5 }}>
                  <MDInput
                    fullWidth
                    type="text"
                    label="Vagarski list"
                    value={vagarskiList}
                    size="small"
                    error={vagarskiListError}
                    key={"vagarskiList"}
                    onChange={(e) => handleChangeVagarskiList(e)}
                    inputProps={{
                      style: { textAlign: "left" },
                    }}
                  />
                </MDBox>
              </MDBox>
            )}
            {!location.state.lokacija.oms && (
              <MDBox display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                <MDBox mb={2} mr={{ xs: 0.5 }}>
                  <MDInput
                    fullWidth
                    type="text"
                    label="Reg. 1"
                    value={reg1}
                    size="small"
                    key={"reg1"}
                    onChange={(e) => handleChangeReg1(e)}
                    inputProps={{
                      style: { textAlign: "left" },
                    }}
                  />
                </MDBox>
                <MDBox mb={2} ml={{ xs: 0.5 }}>
                  <MDInput
                    fullWidth
                    type="text"
                    label="Reg. 2"
                    value={reg2}
                    size="small"
                    key={"reg1"}
                    onChange={(e) => handleChangeReg2(e)}
                    inputProps={{
                      style: { textAlign: "left" },
                    }}
                  />
                </MDBox>
              </MDBox>
            )}
            {!location.state.lokacija.oms && (
              <MDBox mb={2}>
                <Autocomplete
                  ListboxProps={{ style: { maxHeight: 250, overflow: "auto" } }}
                  options={listRoba}
                  value={roba}
                  defaultValue={defaultRoba}
                  autoHighlight
                  loadingText={"Loading..."}
                  onChange={(event, newValue) => setRoba(newValue)}
                  onInputChange={onRobaInputChange}
                  getOptionLabel={(option) => option.title}
                  size="small"
                  id={"Roba"}
                  key={"Roba"}
                  // freeSolo
                  fullWidth
                  renderInput={(params) => (
                    <MDInput {...params} error={robaError} type="text" label={"Roba"} />
                  )}
                  filterOptions={(options, state) => options}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </MDBox>
            )}
            <MDBox display={"flex"} mb={1} alignItems={"center"}>
              <Autocomplete
                ListboxProps={{ style: { maxHeight: 250, overflow: "auto" } }}
                options={listVlasnik}
                value={vlasnik}
                defaultValue={defaultVlasnik}
                autoHighlight
                loadingText={"Loading..."}
                onChange={(event, newValue) => setVlasnik(newValue)}
                onInputChange={onPartnerInputChange}
                getOptionLabel={(option) => option.title}
                size="small"
                id={"Vlasnik"}
                key={"Vlasnik"}
                // freeSolo
                fullWidth
                renderInput={(params) => (
                  <MDInput {...params} error={vlasnikError} type="text" label={"Vlasnik"} />
                )}
                filterOptions={(options, state) => options}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
              <MDBox display={"flex"} ml={1}>
                <MDButton
                  ml={2}
                  variant="contained"
                  color={darkMode ? "white" : "dark"}
                  size={"medium"}
                  onClick={snpOn}
                  iconOnly
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mb={2}>
              <Autocomplete
                ListboxProps={{ style: { maxHeight: 250, overflow: "auto" } }}
                options={listPrimatelj}
                value={primatelj}
                defaultValue={defaultPrimatelj}
                autoHighlight
                loadingText={"Loading..."}
                onChange={(event, newValue) => setPrimatelj(newValue)}
                onInputChange={onPartnerInputChange}
                getOptionLabel={(option) => option.title}
                size="small"
                id={"Primatelj"}
                key={"Primatelj"}
                // freeSolo
                fullWidth
                renderInput={(params) => (
                  <MDInput {...params} error={primateljError} type="text" label={"Primatelj"} />
                )}
                filterOptions={(options, state) => options}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            </MDBox>
            <MDBox mb={2}>
              <Autocomplete
                ListboxProps={{ style: { maxHeight: 250, overflow: "auto" } }}
                options={listIsporucitelj}
                value={isporucitelj}
                defaultValue={defaultIsporucitelj}
                autoHighlight
                loadingText={"Loading..."}
                onChange={(event, newValue) => setIsporucitelj(newValue)}
                onInputChange={onPartnerInputChange}
                getOptionLabel={(option) => option.title}
                size="small"
                id={"Isporucitelj"}
                key={"Isporucitelj"}
                // freeSolo
                fullWidth
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    error={isporuciteljError}
                    type="text"
                    label={"Isporučitelj"}
                  />
                )}
                filterOptions={(options, state) => options}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label={"Napomena"}
                value={napomena}
                fullWidth
                size="small"
                // error={napomenaError}
                key={"napomena"}
                onChange={(e) => setNapomena(() => e.target.value)}
              />
            </MDBox>
            <MDBox display={"flex"} justifyContent={"center"}>
              {!location.state.lokacija.oms && (
                <MDBox mb={2}>
                  <MDInput
                    fullWidth
                    type="text"
                    label="Netto"
                    value={netto}
                    size="small"
                    error={nettoError}
                    key={"netto"}
                    onChange={(e) => handleChangeNetto(e)}
                    inputProps={{
                      style: { textAlign: "left" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <MDTypography variant={"button"} textTransform={"none"}>
                            kg
                          </MDTypography>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
              )}
              {!location.state.lokacija.oms && false && (
                <MDBox mb={2}>
                  <ToggleButtonGroup
                    size={"small"}
                    sx={{ marginLeft: "1rem" }}
                    color={"primary"}
                    //value={alignment}
                    exclusive
                    //onChange={handleChange}
                    aria-label={"Smjer"}
                  >
                    <EDToggleButton
                      value={"ulaz"}
                      aria-label={"Ulaz"}
                      sx={{ textTransform: "none" }}
                    >
                      <UlazIcon />
                      &nbsp;Ulaz
                    </EDToggleButton>
                    <EDToggleButton
                      value={"izlaz"}
                      aria-label={"Izlaz"}
                      sx={{ textTransform: "none" }}
                    >
                      <IzlazIcon />
                      &nbsp;Izlaz
                    </EDToggleButton>
                  </ToggleButtonGroup>
                </MDBox>
              )}
            </MDBox>
            {avatars}
            <MDBox display={"flex"} justifyContent={"center"} mb={2}>
              <MDBox m={1} display={"flex"}>
                <MDButton variant="gradient" color="error" onClick={cancelON}>
                  Cancel
                </MDButton>
              </MDBox>
              <MDBox display={"flex"} m={1}>
                <MDButton
                  disabled={okDisabled}
                  variant="gradient"
                  color="info"
                  onClick={(e) => handleSubmitAnaliza(e)}
                >
                  OK
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout2>
  );
}

export default Anal;
